import { render, staticRenderFns } from "./ShuttleTicket.vue?vue&type=template&id=776cb8dc&scoped=true&"
import script from "./ShuttleTicket.vue?vue&type=script&lang=js&"
export * from "./ShuttleTicket.vue?vue&type=script&lang=js&"
import style0 from "./ShuttleTicket.vue?vue&type=style&index=0&id=776cb8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776cb8dc",
  null
  
)

export default component.exports